module.exports = __webpack_public_path__ + "img/24.c6f4f4f3.png";